import { render, staticRenderFns } from "./SecondStep.vue?vue&type=template&id=10fbb2ba&scoped=true&lang=html&"
import script from "./SecondStep.vue?vue&type=script&lang=ts&"
export * from "./SecondStep.vue?vue&type=script&lang=ts&"
import style0 from "./SecondStep.vue?vue&type=style&index=0&id=10fbb2ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fbb2ba",
  null
  
)

export default component.exports